import {passwordStrength} from 'check-password-strength';

export const passwordStrengthDefaultOptions = [
  {
    id: 0,
    value: 'Too weak',
    minDiversity: 0,
    minLength: 0,
  },
  {
    id: 1,
    value: 'Weak',
    minDiversity: 2,
    minLength: 6,
  },
  {
    id: 2,
    value: 'Medium',
    minDiversity: 4,
    minLength: 8,
  },
  {
    id: 3,
    value: 'Strong',
    minDiversity: 4,
    minLength: 10,
  },
];
export const diversity = ['lowercase', 'uppercase', 'symbol', 'number'];

export const isValidPassword = (passwordField, compareWith = null) => {
  const passwordValidationInfo = passwordStrength(passwordField.value, passwordStrengthDefaultOptions);

  if (compareWith && compareWith.value !== passwordField.value) {
    return  false;
  }

  return (
    passwordValidationInfo.contains.includes('lowercase') &&
    passwordValidationInfo.contains.includes('uppercase') &&
    passwordValidationInfo.contains.includes('symbol') &&
    passwordValidationInfo.contains.includes('number') &&
    passwordValidationInfo.length >= 8
  );
}

const renderPasswordValidationInfo = (passwordField, infoContainer, compareWith = null) => {
  const passwordValidationInfo = passwordStrength(passwordField.value, passwordStrengthDefaultOptions);

  let passwordTpl = '<div class="password-error">';
  passwordTpl += `<span class="password-error__title">Password must contain the following:</span>
                            <span class="${passwordValidationInfo.contains.includes('lowercase') ? 'success' : 'error'}">A lowercase letter</span>
                            <span class="${passwordValidationInfo.contains.includes('uppercase') ? 'success' : 'error'}">A capital (uppercase) letter</span>
                            <span class="${passwordValidationInfo.contains.includes('symbol') ? 'success' : 'error'}">A symbol</span>
                            <span class="${passwordValidationInfo.contains.includes('number') ? 'success' : 'error'}">A number</span>
                            <span class="${passwordValidationInfo.length >= 8 ? 'success' : 'error'}">Minimum 8 characters</span>`;
  if (compareWith) {
    passwordTpl += `<span class="${compareWith.value === passwordField.value ? 'success' : 'error'}">Passwords should match</span>`;
  }
  passwordTpl += '</div>';

  return passwordTpl;
}

export const validatePasswordField = (passwordField, infoContainer, compareWith = null) => {
  if (passwordField) {
    passwordField.addEventListener('keyup', (e) => {

      infoContainer.innerHTML = renderPasswordValidationInfo(passwordField, infoContainer, compareWith);
    });
  }

  if (compareWith) {
    compareWith.addEventListener('keyup', (e) => {
      infoContainer.innerHTML = renderPasswordValidationInfo(passwordField, infoContainer, compareWith);
    });
  }
}
